<template>
  <tr>
    <td data-test="phase-name">
      {{ phaseName | formatNoData }}
    </td>
    <td data-test="evaluation-name">
      {{ evaluationName | formatNoData }}
    </td>
    <td
      data-test="evaluation-comment"
      class="pega-pre-wrap pega-break"
      v-text="$options.filters.formatNoData(evaluationComment)"
    />
  </tr>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  filters: {
    formatNoData (data) {
      return data || 'ー'
    }
  },
  props: {
    selection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      phaseName: _.get(this, 'selection.phase.name', null),
      evaluationName: _.get(this, 'selection.evaluation.name', null),
      evaluationComment: this.selection.evaluationComment
    }
  },
  computed: {
    ...mapGetters('settings', [
      'responsibles',
      'allStatuses'
    ]),
    ...mapGetters([
      'evaluationMaster'
    ])
  }
}
</script>
